import React,{useState,useEffect} from 'react';
import Header from "../../component/Header";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../component/Loader";
import { Link } from 'react-router-dom';
import Message from "../../component/Message";
import { forgotpassword } from '../../Redux/action/stdAuth';


export const Forgotpassword = () => {

    const dispatch = useDispatch()

    const {loading, errorrrr,message} = useSelector(state => state.forgotpasswordreducer)

    const [email,setemail] = useState('')

    const handlesubmit = (e) => {
        e.preventDefault()
        dispatch(forgotpassword(email))
    }

    return(
        <>
        <Header/>
        <main style={{display: 'flex',alignItems: 'center',justifyContent:'center',minHeight:'80vh'}}>
          
          <div class="form">
            <div class="heading">
              <h2>Forgot Password</h2>
            </div>
        <form onSubmit={handlesubmit}>
              <label>
                <div class="icon">
                  <i class="fas fa-envelope"></i>
                </div>

                <input
                  value={email}
                  onChange={(e) => setemail(e.target.value)}
                  type="email"
                  placeholder="Enter Your Email Address"
                />
              </label>
              {loading ? <Loader /> : <input type="submit" value="Sign in" />}
              <div style={{display:'flex',alignItems: 'center',justifyContent: 'center',marginTop:'10px'}}>
            <Link to="/stdLogin" style={{color:'green',textDecoration: "none",fontSize:'22px',fontWeight:'bold'}}>
              Back to Login Page
            </Link>
          </div>
              {errorrrr && <Message variant="danger">{message}</Message>}
              {message && <Message variant="success">{message}</Message>}
            </form>
          </div>
          </main>
          </>
    )

}